import { render } from "./DyAccountManagement.vue?vue&type=template&id=5ba30a82&scoped=true"
import script from "./DyAccountManagement.vue?vue&type=script&lang=js"
export * from "./DyAccountManagement.vue?vue&type=script&lang=js"

import "./DyAccountManagement.vue?vue&type=style&index=0&id=5ba30a82&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ba30a82"]])

export default __exports__